
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import PageBase from "../../../../engines/modules/uiModule/PageBase";
import { OilFieldBuyPrams } from "../../../../engines/modules/uiModule/UIPrams";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { getOilfieldKengConfig, getOilfieldSpecialConfig } from "./config/oilfieldConfig";

const { ccclass, property } = cc._decorator;

@ccclass
export default class oilSpecialItemPage extends PageBase {
    @property({ type: cc.Sprite, displayName: "图片" })
    img_special: cc.Sprite = null;
    @property({ type: cc.Label, displayName: "信息" })
    lab_tips: cc.Label = null;
    @property({ type: cc.Node, displayName: "金额节点" })
    node_money: cc.Node = null;
    @property({ type: cc.Label, displayName: "金额" })
    lab_price: cc.Label = null;

    @property(cc.Label)
    labelAdText: cc.Label = null;

    @property(cc.Node)
    nodeAd: cc.Node = null;

    private bWin = false;
    prams: OilFieldBuyPrams = null;
    callBack: () => void = null;
    async OnPageOpen(prams?: OilFieldBuyPrams) {
        this.nodeAd.active = false;
        if (prams) {
            this.prams = prams;
            let info = getOilfieldSpecialConfig[prams.id];
            utilsView.loadItemImg('res/event/'+ info.eventSpritePath, this.img_special, null, BUNDLE_SMALL_NAME.oilfield);
            this.lab_tips.string = info.tips;
            this.node_money.active = info.getMoney != null;
            if (this.node_money.active) {
                this.nodeAd.active = true;
                let bWin = this.bWin = info.getMoney > 0;
                this.lab_price.string = data_control.getNumberFormat(info.getMoney);
                this.labelAdText.string = bWin ? '双倍领取' : "保住本钱";
            }

            this.callBack = prams.callBack;
        }
        super.OnPageOpen(prams)
    }

    onClickSure(event: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        let info = getOilfieldSpecialConfig[this.prams.id]
        if (info.getMoney != null) {
            let node = event.getCurrentTarget();
            O1HD.getServices().userSrv.setCoins(info.getMoney, true, info.getMoney > 0 ? node : null);
        }
        this.OnCloseBtn();
        this.callBack && this.callBack();
    }

    onClickAd(event: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        utilsModel.loadAndShowVideoAdTrans(()=>{
            if (this.bWin) {
                let node = event.getCurrentTarget();
                let info = getOilfieldSpecialConfig[this.prams.id]
                if (info.getMoney != null) {
                    O1HD.getServices().userSrv.setCoins(info.getMoney * 2, true, node);
                }
            }
            this.OnCloseBtn();
            this.callBack && this.callBack();
        },()=>{

        },null,"金矿广告保住或领取双倍收益");
    }
}